import { getEnvironment } from "@p0security/frontend-core";
import { visibleComponentKeys } from "@p0security/shared/install/options";
import { integrationRegistry } from "@p0security/shared/integrations/registry";
import type { RegisteredResourceIntegration } from "@p0security/shared/integrations/types";
import { widetype } from "@p0security/util/collections";
import type { LDFlagSet } from "launchdarkly-react-client-sdk";
import { camelCase, compact, sortBy } from "lodash";

import { IntegrationData } from "./types";

export const registryToIntegrationData = (
  flags: LDFlagSet | undefined,
  type: RegisteredResourceIntegration["category"],
  docRoot: string
): IntegrationData[] =>
  sortBy(
    compact(
      Object.entries(integrationRegistry).map(
        (entry: [string, RegisteredResourceIntegration]) => {
          const [key, registration] = entry;
          const { category, components, docs, flag, label, logoUrl } =
            registration;
          return (
            // LaunchDarkly's web SDK automatically converts kebab-case flags to camel-case, so we need to mirror that here
            (!flag || flags?.[camelCase(flag)]) &&
            category === type &&
            components && {
              availableComponents:
                components !== "oauth"
                  ? visibleComponentKeys(
                      components,
                      getEnvironment().environmentType,
                      flags
                    )
                  : undefined,
              docs: widetype.mapValues({ install: 0, request: 0 }, (_, k) =>
                docs[k] ? `${docRoot}/${docs[k]}` : undefined
              ),
              icon: logoUrl,
              key,
              label: label,
            }
          );
        }
      )
    ),
    "label"
  );
